import React from 'react'
import Paper from 'material-ui/Paper'
import { Redirect } from 'react-router-dom'

import { Container } from '../Login/styles'
import ResetForm from '../../components/ResetForm'
import FooterMenu from '../../components/FooterMenu'
import SignupComplete from '../../components/SignupComplete'
import { isActivate, isChangeEmail, parseQuery } from '../../lib'

const Loading = () => (
  <div className="h-100 flex justify-center items-center">Loading...</div>
)

const ResetPassword = props => {
  const queries = parseQuery(props.location.search)
  return !props.location.search ? (
    <Redirect
      to={'/'}
    />
  ) : (
    <div className="flex justify-center flex-column items-center h-100">
      <Container>
        <Paper className="pa4" zDepth={3}>
          {props.isValidating ? (
            <Loading/>
          ) : props.expired ? (
            <SignupComplete
              expired={props.expired}
              location={props.location.pathname}
            />
          ) : isActivate(props.location.pathname) ? (
            <SignupComplete
              activate
              expired={props.expired}
              location={props.location.pathname}
            />
          ) : props.isUpdating ? (
            <Loading/>
          ) : props.resetSuccess ? (
            <SignupComplete
              reset
              expired={props.expired}
              location={props.location.pathname}
            />
          ) : isChangeEmail(props.location.pathname) ? (
            <SignupComplete
              changeEmail
              expired={props.expired}
              location={props.location.pathname}
            />
          ) : (
            <ResetForm queries={queries} {...props} />
          )}
        </Paper>
        <FooterMenu/>
      </Container>
    </div>
  )
}

export default ResetPassword



// WEBPACK FOOTER //
// src/routes/ResetPassword/ResetPassword.js